// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"70":"36857c29","354":"16ba25e8","691":"201d4483","827":"16ba25e8","995":"057f52c0"}[chunkId] + ".chunk.css");